
import { CONSTANTS } from "../../constants";

export default {
  name: "ChatbotProductPage",
  data: () => ({
    BANNER_DETAILS: CONSTANTS.DELIVERY_SYSTEM_BANNER_DETAILS,
    CLIENTS: ["Janta Transport", "Janta Roadways"],
    REVIEWS: CONSTANTS.REVIEWS,
    features: [
      {
        name: "User App",
        description: [
          {
            data: "Engaging and Intuitive Experience, our User App is crafted to provide end-users with a seamless shopping and delivery experience. Key features include:",
          },
          {
            title: "Product Browsing",
            data: " Users can easily browse and view products with a stunning and customizable UI.",
          },
          {
            title: "Order Placement",
            data: " Simple and secure order placement process.",
          },
          {
            title: "Payment Integration",
            data: "  Multiple payment options for user convenience.",
          },
          {
            title: "Delivery Tracking",
            data: "Real-time tracking of orders from dispatch to delivery. ",
          },
        ],
        imageName: "/delivery-system/ds1.png",
      },
      {
        name: "Packer App",
        description: [
          {
            data: "Streamline Order Management; tailored for store and packing personnel, making the organization and preparation of shipments a breeze. Key features include:",
          },
          {
            title: "Order Management",
            data: "Seamlessly manage incoming orders and items, ensuring no order is missed.",
          },
          {
            title: "Efficient packing",
            data: " Intuitive interface for packing items, minimizing errors, and maximizing efficiency.",
          },
          {
            title: "Inventory Tracking",
            data: " Real-time updates on inventory levels, ensuring concurrency on the inventory level.",
          },
        ],
        imageName: "/delivery-system/ds2.png",
      },
      {
        name: "Delivery App",
        description: [
          {
            data: "Empower Your Delivery Personnel, designed to assist your delivery staff in getting packages to customers quickly and accurately. Key features include:",
          },
          {
            title: "Route Optimization",
            data: "Intelligent routing for the fastest delivery times.",
          },
          {
            title: "Real-Time Tracking",
            data: " Customers can track their packages in real-time, enhancing transparency.z",
          },
          {
            title: "Efficient Delivery",
            data: " Fast and easy-to-use user interface for faster deliveries and package pickups with real-time alerts.",
          },
        ],
        imageName: "/delivery-system/ds3.png",
      },
      {
        name: "Unified Admin Panel",
        description: [
          {
            data: "Comprehensive Analytics and Control, gain complete oversight of your delivery operations with our robust Admin Panel. Admin Panel can be integrated with our POS and E-commerce Admin Panel as well. Key features include:",
          },
          {
            title: "Analytics & Reporting",
            data: "  Detailed insights into delivery performance, order status, and comprehensive analytic generation to make informed decisions and improve your delivery operations.",
          },
          {
            title: "Performance Monitoring",
            data: " Track the efficiency of packers and delivery personnel.",
          },
          {
            title: "Custom Alerts",
            data: " Set up alerts for specific events or thresholds, keeping you informed at all times.",
          },
          {
            title: "Built to scale",
            data: " Our On-Demand Delivery System seamlessly integrates with AiBuddha's POS and E-commerce solutions, providing a unified platform for all your business needs..",
          },
        ],
        imageName: "/delivery-system/ds4.png",
      },
    ],
  }),

  head() {
    return {
      title: "On-demand Delivery System by AiBuddha",
      description: "On-demand Delivery System by AiBuddha",
    };
  },
};
